import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  padding: 34px 40px 40px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 24px 24px 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .close {
    border: none;
    background: none;

    width: 36px;
    height: 36px;

    position: absolute;

    top: 20px;
    right: 20px;

    svg {
      path {
        stroke: rgb(${({ theme }) => theme.grayscale[100]});
      }
    }
  }

  .alert-icon {
    width: 56px;
    height: 56px;

    color: rgb(${({ theme }) => theme.primary.base});

    margin-bottom: 16px;
  }

  .title {
    color: rgb(${({ theme }) => theme.grayscale[100]});

    font-size: 18px;
    font-weight: 700;
    line-height: 120%;

    text-align: center;

    margin-bottom: 48px;
  }

  .description {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    font-weight: 500;
    line-height: 120%;

    text-align: center;

    margin-bottom: 36px;

    .icon {
      flex-shrink: 0;
      color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#5E6871')};
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;

    width: 100%;

    button {
      border-radius: 4px;

      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 140%;
    }

    .delete {
      color: ${({ theme }) => `rgb(${theme.background.low})`};

      background-color: rgb(${({ theme }) => theme.primary.base});

      height: 52px;

      transition: opacity 0.3s ease;

      border: none;

      &:disabled {
        opacity: 0.6;
        cursor: progress;
      }

      .loader {
        width: 32px;
        height: 32px;
      }
    }

    .cancel {
      background: none;

      padding: 14px;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }
  }

  @media only screen and (min-width: 800px) {
    border-radius: 6px;

    padding: 50px 40px;

    min-width: 590px;

    .alert-icon {
      width: 72px;
      height: 72px;

      margin-bottom: 24px;
    }

    .title {
      font-size: 22px;

      margin-bottom: 42px;
    }

    .description {
      margin-bottom: 56px;
    }

    .buttons {
      width: fit-content;

      flex-direction: row;
      justify-content: center;
      gap: 38px;

      button {
        width: 142px;
      }
    }
  }
`
